import {EventHandler} from "@utility/eventHandler";

export type TServerData = object | string | number | boolean | null;

export interface IScore {
    name: string
    score: number
    userID: string
}
export abstract class BaseServices {
    abstract initialise(): Promise<boolean>;
    abstract get name(): string;

    get authenticated() {
        return false;
    }

    cloud(name: string, _?: any): Promise<any> {
        return Promise.resolve(false);
    }

    getLeaderboard(): Promise<IScore[]> {
        return Promise.resolve([]);
    }

    getLoggedIn() { 
        return false;
    }

    getSupports(_: string) {
        return false;
    }

    getUserID(): string | null {
        return null;
    }

    getUserName(): string | null {
        return null;
    }

    getUserProp(_: string): any | null {
        return null;
    }

    get(key: string): Promise<TServerData> {
        return Promise.resolve(null);
    }

    async linkAccounts() {
        return false;
    }

    logEvent(event: string, params: any = {}) {}

    async logIn(props: Record<string, any>) {
        return false;
    }

    logOut(): void {}

    onValue(key: string): Promise<TServerData> {
        return Promise.resolve(null);
    }

    put(key: string, data: TServerData): Promise<boolean> {
        return Promise.resolve(false);
    }

    async resetPassword(_: string) {
        return Promise.resolve(false);
    }

    async signUp(props: Record<string, any>) {
        return false;
    }

    submitAchievement(achievement: string) {
        return Promise.resolve(false);
    }

    submitScore(score: number) {
        return Promise.resolve(false);
    }
}
